<template>
  <ThreeColumn :breadcrumbPaths="paths">
    <template v-slot:title>
      <h1 class="text-h1 mb-0">{{$t('operators.page_title')}}</h1>
    </template>

    <template v-slot:leftPanel>
      <TocWidget :toc="contentswdgt"></TocWidget>
    </template>

    <template v-slot:mainPanel>
       
      <h2 id="helpoperators" class="text-h2 liiblack--text mt-1 mb-4">{{$t('operators.t_operators')}}</h2>

        <p class="mb-5">{{$t('operators.operators[0]')}}</p>

        <table class="optable mb-10" columns="3" width="100%" cellspacing="0">
          <thead>
            <tr>
            <td width="35%" class="pl-1 py-1"><b>Operator</b></td>
            <td width="20%" class="py-1"><b>Example(s)</b></td>
            <td width="45%" class="py-1"><b>Explanation</b></td>
          </tr>
          </thead>

          <tbody>
          <tr>
            <td class="pl-1 pr-1">
              <b><i>word</i></b>
              <ul>
                <!-- <li>Note that plural words are matched with singular words automatically (and vice versa), provided that the match whole word option is disabled.</li> -->
                <li>Case insensitive</li>
              </ul>
            </td>
            <td><br/>copyright</td>
            <td><br/>
              <!-- <p>Returns all documents containing that word. Note that plural words are matched with singular words automatically (and vice versa). So searching for "contract" includes searching for "contracts" and "strategy" is considered the same as "strategies". Words and phrases are case insensitive. So "bob" is the same as "Bob" or "BOB".</p> -->
              <p>Returns all documents containing that word. Words and phrases are case insensitive. So "bob" is the same as "Bob" or "BOB".</p>
            </td>
          </tr>

          <tr>
            <td  class="pl-1 pr-1">
              <b><i>wildcards</i></b>
              <ul>
              <li>An asterisk <b class="operator">*</b> matches any string (including none)</li>
              <li>A question mark <b class="operator">?</b> matches any single character</li>
              </ul>
            </td>
            <td><br/>
                tax<b>*</b>
                <br><br>
                licen<b>?</b>e
            </td>
            <td><br/>
              <p>Returns all documents containing a word beginning with tax -  this would include: <b>tax</b>, <b>tax</b>es, <b>tax</b>i, <b>taxi</b>cab, <b>tax</b>ation, <b>tax</b>able, <b>tax</b>ing, <b>tax</b>idermy. Note: using the asterisk slows down searching significantly.</p>
              <!-- Returns all documents containing the word "licen<b>c</b>e" or "licen<b>s</b>e" including the plurals of those words. -->
              Returns all documents containing the word "licen<b>c</b>e" or "licen<b>s</b>e".
            </td>
          </tr>

          <tr>
            <td  class="pl-1 pr-1">
              <b><i>phrase</i></b>
              <ul>
              <li>Use double quotation marks <b class="operator"> " "</b> for phrases (see explanation at right)</li>
              </ul>
            </td>
            <td><br/><b>"</b>moral rights<b>"</b><br/>
            <b>"</b>moral and rights<b>"</b></td>
            <td>
              <p>Returns all documents containing that phrase.</p>
              Without the double quotation marks the search will be for all documents with moral that also contain
              the word rights (the two words not necessarily appearing next
              to each other).
            </td>
          </tr>

          <tr>
            <td class="pl-1 pr-1">
              <b>AND</b>
              <ul>
              <li>Boolean operator</li>
              <li>Document must have both words (or both phrases)</li>
              <li>Can be written <b class="operator">AND</b> or <b class="operator">and</b></li>
              <li>Synonyms: <b class="operator">&amp;</b>, <b class="operator">&amp;&amp;</b></li>
              </ul>
            </td>
            <td><br/>copyright <b>AND</b> moral rights</td>
            <td>
              Returns all documents that contain <b>both</b> the first term
              <b>and</b> the second term. A "term" can be a single word or
              complete phrase (no quotes are necessary around a phrase).
              Only works when your search is set to <b>Boolean</b> mode.
            </td>
          </tr>

          <tr>
            <td  class="pl-1 pr-1">
              <b>OR</b>
              <ul>
              <li>Boolean operator</li>
              <li>Document can have either word (or either phrase)</li>
              <li>Can be written <b class="operator">OR</b> or <b class="operator">or</b></li>
              <li>Synonyms: <b class="operator">|</b>, <b class="operator">||</b></li>
              </ul>
            </td>
            <td><br/>treaties <b>OR</b> conventions</td>
            <td>
              <p>Returns all documents that contain <b>either</b> the first
              term <b>or</b> the second term <b>or both</b>. A "term" can be
              a single word or complete phrase. Only works when your search
              is set to <b>Boolean</b> mode. Most useful when searching for
              synonyms of words.</p>
            </td>
          </tr>

          <tr>
            <td class="pl-1 pr-1">
              <b>NOT</b>
              <ul>
              <li>Boolean operator</li>
              <li>Document must have first term. Must <b>not</b> have
              second</li>
              <li>Can be written <b class="operator">NOT</b> or <b class="operator">not</b></li>
              </ul>
            </td>
            <td><br/>love <b>NOT</b> war</td>
            <td>
              <p>Finds documents that contain the first word, but do <b>not</b>
              contain the second. Occassionally useful to exclude irrelevant
              documents that contain unique words or titles. Only works
              in <b>Boolean</b> mode. You can also use "and not", for
              example "love and not war" (without the quotes of course).</p>
            </td>
          </tr>

          <tr>
            <td class="pl-1 pr-1">
              <b>NEAR</b>
              <ul>
              <li>Proximity operator</li>
              <li>Synonym for <b class="operator">w/50</b> (see below)</li>
              <li>Words or phrases must be within 50 words of each other</li>
              <li>Order of terms not important</li>
              </ul>
            </td>
            <td><br/>mabo <b>NEAR</b> queensland<br></td>
            <td>
              <p>Returns all documents where the first term appears nearby
              the second term. "Near" corresponds to 50 words, which is intended
              to be roughly the size of a paragraph. If two words are close
              together, then the chance of them being related is increased.
              Only works when your search is set to <b>Boolean</b> mode. Useful
              when searching for references to case names.</p>
            </td>
          </tr>

          <tr>
            <td class="pl-1 pr-1">
              <b>w/<i>n</i></b>
              <ul>
              <li>Proximity operator</li>
              <li>Can use any number after slash <br>(1 to 1000)</li>
              <li>Order of terms not important <br>(i.e. "a <b class="operator">w/5</b> b" same as "b <b class="operator">w/5</b>
              a")</li>
              </ul>
            </td>
            <td><br/>mabo <b>w/5</b> queensland<br></td>
            <td>
              <p>Returns all documents where the first term appears within
              <b><i>n</i></b> words of the second term, where <b><i>n</i></b>
              is a number you specify. So you could use "mabo w/10 queensland",
              "mabo w/50 queensland" (same as using <b>near</b>) or
              "mabo w/100 queensland". If two words are clsoe together, then
              the chance of them being related is increased. Only works when
              your search is set to <b>Boolean</b> mode. Useful when searching
              for references to case names.</p>
            </td>
          </tr>

          <tr>
            <td class="pl-1 pr-1">
              <b>pre/<i>n</i></b>
              <ul>
              <li>Proximity operator</li>
              <li>Can use any number after slash <br>(1 to 1000)</li>
              <li>Order of terms important <br>(i.e. "a <b class="operator">pre/10</b> b" is different to "b
              <b class="operator">pre/10</b> a")</li>
              </ul>
            </td>
            <td><br/>sentencing <b>pre/5</b> statistics<br></td>
            <td>
              <p>Returns all documents where the first term precedes the second
              term by no more than <b><i>n</i></b> words, where N is a number you
              specify. This means that the first term must come before the
              second term in the document, separated by no more than <b><i>n</i></b>
              words. Examples might be "sentencing pre/10 statistics",
              "sentencing pre/50 statistics" or "sentencing pre/100 statistics".
              Only works in <b>Boolean</b> mode.</p>
            </td>
          </tr>

          <tr>
            <td class="pl-1 pr-1">
              <b>/<i>n</i>/</b>
              <ul>
              <li>Proximity operator</li>
              <li>Same as <b class="operator">w/<i>n</i></b> operator (above)</li>
              <li>Emulated <i>STATUS</i> operator</li>
              </ul>
            </td>
            <td><br/>smith<b>/10/</b>brown<br></td>
            <td>
              <p>Finds documents where words and phrases appear within <b><i>n</i></b>
              words of each other (as in the old <i>STATUS</i> system),
              where <b><i>n</i></b> is a number you specify. Similar in
              function to <b>W/<i>n</i></b> (see above).</p>
            </td>
          </tr>

          <tr>
            <td class="pl-1 pr-1">
              <b>/<i>m</i>,<i>n</i>/</b>
              <ul>
              <li>Proximity operator</li>
              <li>Finer control than <b class="operator">w/<i>n</i></b> (above)</li>
              <li>Emulated <i>STATUS</i> operator</li>
              </ul>
            </td>
            <td><br/>smith<b>/-10,10/</b>brown <br>
                      smith<b>/1,10/</b>brown</td>
            <td>
              <p>Finds documents where words and phrases appear somewhere within
              <i>m</i> to <i>n</i> words of each other. You can use a negative
              value for <i>m</i> to mean "this many words before the second"
              and a positive value to mean "this many words after the second".</p>
            </td>
          </tr>

          <tr>
            <td class="pl-1 pr-1">
              <b>title( ... )</b>
              <ul>
              <li>Field operator</li>
              <li>Limit search to title of document</li>
              <li>Also limits to case names</li>
              <li>Also limits to section and regulation names for legislation</li>
              </ul>
            </td>
            <td>
              <b><br/>title(</b>commonwealth<b>)</b><br>
              commonwealth<b>@title</b><br><br>
              <i>But use:</i> <b>title(</b>commonwealth bank<b>)</b><br>
              <i>and not:</i> commonwealth bank<b>@title</b><br>
            </td>
            <td>
              <p>Limits the search to document titles only. The example will
              find all those files with the word "commonwealth" in the title.
              This only works in <b>Boolean</b> mode, and can be combined with
              other operators. The text inside the title can contain other
              operators as well. This is a valid search: "title(westpac OR suncorp)
              AND title(australian taxation office OR ATO)".</p>
            </td>
          </tr>

          <tr >
            <td class="pl-1 pr-1">
              <b><i>punctuation</i></b>
              <ul>
              <li>Replace all punctuation with a space in searches</li>
              <li>Only use double quotation marks for phrases</li>
              </ul>
            </td>
            <td><br/><b>[ ] { } ^ + - ,</b><br></td>
            <td>
              <p>As a general rule, omit <b>all</b> punctuation in your searches by replacing it
              with space characters, since some characters have a special meaning that
              could yield unpredictable results.</p>
            </td>
          </tr>
          </tbody>
        </table>

      <br/>
      <br/>

      <h2 id="helpprecedence" class="text-h2 liiblack--text mt-3 mb-4">{{$t('operators.t_precedence')}}</h2>

      <p class="mb-5">{{$t('operators.operators[1]')}}</p>

      <table columns="3" width="100%" cellpadding="10" cellspacing="0">
        <thead>
          <tr>
            <td width="35%" class="pl-1 py-1"><b>Precedence Rules</b></td>
            <td width="20%" class="py-1"><b>Example</b></td>
            <td width="45%" class="py-1"><b>Explanation</b></td>
          </tr>
        </thead>

        <tbody>
        <tr>
          <td>
            Default precedence rules:
            <ol>
              <li><i>word</i></li>
              <li><b class="operator">(</b><i>terms</i><b class="operator">)</b> <i>phrase</i></li>
              <li><b class="operator">NOT</b></li>
              <li><span class="operator mr-2"> <b>w/</b><i>n</i></span>
                  <span class="operator mr-2"><b>pre/</b><i>n</i></span> 
                  <span class="operator mr-2"><b>/</b><i>n</i><b>/</b></span> <br>
                  <span class="operator mr-2"><b>/</b><i>m</i><b>,</b><i>n</i><b>/</b><i>word</i></span>
                  <span class="operator mr-2"><b>@title</b></span> 
                  <span class="operator mr-2"><b>title(</b><i>phrase</i><b>)</b></span>
              </li>
              <li><b class="operator mr-2">OR</b> 
                  <b class="operator  mr-2">|</b> 
                  <b class="operator mr-2">||</b>
              </li>
              <li>
                <b class="operator mr-2">AND</b> 
                <b class="operator mr-2">&amp;</b> 
                <b class="operator mr-2">&amp;&amp;</b>
              </li>
            </ol>
          </td>
          <td>
            <b>(</b>crime <b>and</b> punishment<b>)</b> <b>or</b> jail
          </td>
          <td>
            <p>Normally, searches are evaluated left to right. There is a
            default precedence order, but it is a good idea to force parts of your
            search to be evaluated first using round brackets. Note that
            the following searches are all different: "journalist AND
            defamation OR publish", "journalist AND (defamation OR publish)"
            and "(journalist AND defamation) OR publish".
          </p></td>
        </tr>
        
        </tbody>
      </table>

      <br/>
      <br/>
      <br/>
      <br/> 
    </template>
  </ThreeColumn>
</template>

<script>
  import ThreeColumn from '@/components/applayout/ThreeColumn'
  import TocWidget from '../components/TocWidget'
  export default {
    name: 'operators',
    components:{
      ThreeColumn,
      TocWidget
    },
    /*watch:{
      '$i18n.locale': function(){
        window.document.title = `${this.$i18n.t('operators.page_title')} | HKLII`
      }
    },*/
    computed:{
      paths(){
        return [
          {text: 'HKLII', disabled: false, href: {name: 'home'}},
          {text: this.$i18n.t('operators.page_title'), disabled: true}
        ]
      },
      contentswdgt(){
        return [
          {'title':this.$i18n.t('operators.t_operators'), id:'helpoperators'},
          {'title':this.$i18n.t('operators.t_precedence'), id:'helpprecedence'},
        ]
      },
    },
    /*mounted(){
      window.document.title = `${this.$i18n.t('operators.page_title')} | HKLII`
    }*/
    metaInfo(){
      return{
        title: this.$i18n.t('operators.page_title'),
      }
    },
  }
</script>

<style scoped>
  table {
    border-bottom: 2px solid var(--v-darkgrey-base);
  }

  tbody td {
    text-align: left;
    vertical-align: top;
    border-top: 1px solid var(--v-darkgrey-lighten2);
    font-size: 10.5pt;
    line-height: 15pt;
    padding-top:4px;
    padding-bottom:10px;
    padding-right:4px;
  }

  thead td {
    border-top: 2px solid var(--v-darkgrey-base);
    background-color: var(--v-footergrey-lighten1); 
  }
  
  li {
    padding-bottom: 5px;
  }

  .operator {
    background: var(--v-rsidebg-base) ;
    padding-left: 3px;
    padding-right: 3px;
  }

</style>